import { render, staticRenderFns } from "./RemitterInfo.vue?vue&type=template&id=506b0bf8&scoped=true&"
import script from "./RemitterInfo.vue?vue&type=script&lang=js&"
export * from "./RemitterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b0bf8",
  null
  
)

export default component.exports